(function (window) {
    $(document).ready(function () {
        // STATE ------------------------------------------------------------------------------------------------------
        var isOverMainNav = false;
        var $header = $("#header-main");
        var lastScrollTop = 0;
        var delta = { up: 200, down: 2 };

        // FUNCTIONS --------------------------------------------------------------------------------------------------

        /**
         * Turns on hover state for current item and header
         * @param {Object} currentItem jquery object of nav item
         */
        function overMainNav(currentItem) {
            //resets
            isOverMainNav = true;
            $(".main .top-level.hover").removeClass("hover");
            $("#header-main .main").removeClass("parent");

            currentItem.addClass("hover");
            currentItem.closest(".main").addClass("hover");
            $("#header-main").addClass("hover");

            setTimeout(function () {
                $("#header-main .main").addClass("already-open");
            }, 150);
        }

        /**
         * Removes the hover state for main menu items
         */
        function offMainNav() {
            isOverMainNav = false;
            setTimeout(function () {
                if (!isOverMainNav) {
                    $("#header-main .main").removeClass("already-open");
                }
            }, 100);
            setTimeout(function () {
                if (!isOverMainNav) {
                    $("#header-main .hover").removeClass("hover");
                    $("#header-main").removeClass("border");
                    $(".top-level.hover").removeClass("hover");
                }
            }, 200);
        }

        /**
         * Sets the position of level 2 container elements based on the horizontal space available
         */
        function setLevel2Position() {
            $("nav.main .level2-container").each(function () {
                var w = Math.floor(document.body.getBoundingClientRect().right - $(this).parent("li")[0].getBoundingClientRect().left - 10);
                var thisWidth = $(this).outerWidth();
                if (w < thisWidth) $(this).addClass("pin-right");
                else $(this).removeClass("pin-right");
            });
        }

        /**
         * Sets the class of the header based on the window scroll position
         */
        function calculateHeaderClass() {
            var y = window.pageYOffset;
            if (y - delta.down > lastScrollTop) {
                //keep track of tucked
                if (y > 1) {
                    $header.addClass("tucked");
                }
                lastScrollTop = y;
            } else if (y + delta.up < lastScrollTop || y < delta.down) {
                $header.removeClass("tucked");
                lastScrollTop = y;
            }

            if (y < delta.down) {
                //keep track of top
                $header.addClass("top");
                top = true;
            } else if (y > delta.down) {
                $header.removeClass("top");
                // close the banner accordion if we scroll down and the banner was open
                if ($("body").hasClass("header-banner-is-open")) {
                    $(".header_banner_accordion").click();
                }
                top = false;
            }

            if (y - delta.down > lastScrollTop || y + delta.up < lastScrollTop)
                //keep track only outside of delta range
                lastScrollTop = y;

        }
        // EVENTS -----------------------------------------------------------------------------------------------------

        // Hover/focus events for top level menu items
        $("nav.main > ul > li.top-level").on('mouseenter focusin',
            function () {
                if (window.innerWidth > 768) {
                    overMainNav($(this));
                }
            }
        );
        $("nav.main > ul > li.top-level").on('mouseleave focusout',
            function () {
                offMainNav();
            }
        );

        //mouse over on level 3
        $("ul.parent > li.parent > a").on('mouseenter',
            function () {
                document.activeElement.blur();
                if (window.innerWidth > 768) {
                    $(this).next().addClass("popup-open");

                    //check to make sure it doesn't go offscreen
                    var el = $("ul.parent.popup-open").last();
                    var container = el.closest('.level2-container');
                    var containerRight = container.offset().left + container.width();
                    var right = el.offset().left + el.width();
                    if (right >= containerRight) {
                        el.css("left", "-200px");
                    }
                }            
            }
        );

        $("ul.parent > li.parent").on('mouseleave',
            function () {
               
                var el = $("ul.parent.popup-open").last();
                el.css("left", "");
                el.removeClass("popup-open");
            }
        );
        $("ul.parent > li.parent").on('focusin',
            function () {
                //check to make sure sublevel doesn't go offscreen
                var el = $(':focus').parent().parent();
                var container = el.closest('.level2-container');
                var containerRight = container.offset().left + container.width();
                var right = el.offset().left + el.width();
                if (right >= containerRight) {
                    el.css("left", "-200px");
                }
            }
        );

        //mobile events
        //expand or collapse mobile elements
        $('span.sub-arrow').click(function (e) {
            e.preventDefault();
            var parent = $(this).parents('li').first();

            if ($(this).hasClass('show')) {
                parent.find('ul.show').filter(':first').removeClass("show");
                $(this).removeClass("show");
            } else {
                parent.find('ul:first').addClass("show");
                $(this).addClass("show");
            }
        });

        // When the mouse leaves the document window, turn off the main nav
        $(document).mouseleave(function () {
            offMainNav();
        });
        //clear focus on window resize
        function windowResize() {
            document.activeElement.blur();
        }
         window.addEventListener("resize", windowResize);

        // INITIAL ACTIONS --------------------------------------------------------------------------------------------
        setLevel2Position();

        // If there is a jquery header object, set up the window scroll event, set the header visible and set its class
        // Cases where there might not be a header include landing page style layouts
        if ($header.length > 0) {

            window.onscroll = function () {
                calculateHeaderClass();
            };

            $header.css("visibility", "visible");           
            calculateHeaderClass();
        }
    });
})(window);